import React from 'react';
import { cn } from '@/lib/utils';
import { Spinner } from '@/components/ui/Spinner/Spinner';

export interface LoadingStateProps {
  /** Size of the spinner */
  size?: 'sm' | 'md' | 'lg';
  /** Minimum height of the container */
  minHeight?: string;
  /** Optional loading text to display below spinner */
  text?: string;
  /** Additional CSS classes */
  className?: string;
}

/**
 * LoadingState - A standardized centered loading spinner
 * 
 * Features:
 * - Centered horizontally and vertically
 * - Configurable min-height
 * - Optional loading text
 * - Uses design system Spinner
 * 
 * @example
 * ```tsx
 * <LoadingState />
 * <LoadingState text="Loading data..." />
 * <LoadingState size="sm" minHeight="200px" />
 * ```
 */
export function LoadingState({
  size = 'lg',
  minHeight = '400px',
  text,
  className,
}: LoadingStateProps) {
  return (
    <div
      className={cn('flex flex-col items-center justify-center', className)}
      style={{ minHeight }}
    >
      <Spinner size={size} />
      {text && (
        <p className="mt-4 text-sm text-muted-foreground">
          {text}
        </p>
      )}
    </div>
  );
}

